import React from 'react';
import usePlanAndLDFlag from '../../../../../hooks/usePlanAndLDFlag';
import Tags from './Tags';
import PaymentRequest from './PaymentRequest';
import SalesOpportunities from './SalesOpportunities';
import Reminders from './Reminders';
import ClientAppointments from '../../../../../componentsV2/Routes/Clients/QuickView/Appointments/ClientAppointments';
import ClientAutoMessages from '../../../../../componentsV2/Routes/Clients/QuickView/AutoMessages/ClientAutoMessages';

const QuickView = props => {
  const appointmentsEnabled = usePlanAndLDFlag('appointments');
  return (
    <div
      className="flex-col-left"
      style={{ alignItems: 'stretch', maxHeight: '100%', gap: '36px', overflowX: 'hidden', paddingLeft: '26px', paddingRight: '26px' }}
    >
      {props?.auth?.merchantFlags?.tags?.enabled && (
        <Tags client={props.client} auth={props.auth} getClientData={props.getClientData} />
      )}

      {appointmentsEnabled && (
        <ClientAppointments
          clientId={props.client.id}
          showMessageHandler={props.showMessageHandler}
          allAssoc={props.allAssoc}
          setViewAllType={props.setViewAllType}
        />
      )}

      <SalesOpportunities
        client={props.client}
        setViewAllType={props.setViewAllType}
        auth={props.auth}
        setSelectedSalesOpp={props.setSelectedSalesOpp}
        getReminderData={props.getReminderData}
        getClientData={props.getClientData}
        refetchReminders={props.refetchReminders}
        refetchAutoMessages={props.refetchAutoMessages}
      />

      <Reminders
        client={props.client}
        setViewAllType={props.setViewAllType}
        auth={props.auth}
        open={props.showPopConfirm}
        closeChat={props.closeChat}
        showMessageHandler={props.showMessageHandler}
        setDismissPopup={props.setDismissPopup}
        dismissPopup={props.dismissPopup}
        allAssoc={props.allAssoc}
        setAssociate={props.setAssociate}
        associate={props.associate}
        refetchReminders={props.refetchReminders}
      />
      <ClientAutoMessages
        clientId={props.client.id}
        setViewAllType={props.setViewAllType}
        client={props.client}
        associate_name={`${props.auth?.firstName || ''} ${props.auth?.lastName || ''}`}
        merchantId={props?.merchantId}
        auth={props.auth}
      />
      <PaymentRequest
        client={props.client}
        setViewAllType={props.setViewAllType}
        showMessageHandler={props.showMessageHandler}
      />
    </div>
  );
};
export default QuickView;
